import { fetch } from '../../api';
import { fetchFeed } from './general';

export default (feedId, threadId, query = {}) => {
  const feed = { id: feedId, dataType: 'messages' };

  const fetchData = async function fetchData() {
    const { payload } = await fetch(
      ['message/thread', threadId].filter(a => !!a).join('/'),
      { query },
    );

    // @FIXME remove when endpoint change
    return { data: { threads: [{ ...payload, hasRead: true }], messages: payload.messages.reverse() } };
  };

  return fetchFeed(feed, !query.fromId, fetchData);
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/feedActionsCreator/message.js